import { AxiosResponse } from "axios";
import { $baseApi } from "../index";
import ResponseBody from "../models/ResponseBody";
import RequestBody from "../models/RequestBody";
import { ExamsPayload } from "../../ui/modules/notifications/interfaces/ExamDiscipline";

export const getExamsRequest = (): Promise<AxiosResponse<ResponseBody<ExamsPayload>>> => {
  return $baseApi.post<ResponseBody<ExamsPayload>>("", new RequestBody("exam", null));
};
